import { render, staticRenderFns } from "./QuestionTypeImage.vue?vue&type=template&id=114e5ceb"
import script from "./QuestionTypeImage.vue?vue&type=script&lang=js"
export * from "./QuestionTypeImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports